<template>
    <div class="newIccStyles">
        <div v-if="hasError" class="error--text">
            There is an error while fetching data from the query.
            Please try again later.
        </div>

        <div v-if="!contentSections.length && xmlIds.length && !isLoading">
            <p>No content found for query <b>"{{ xmlIds }}"</b></p>
        </div>
        <div v-else>
            <content-section
                v-for="contentSection in contentSections"
                :key="contentSection.sectionId"
                :contentSection="contentSection"
                @breadcrumb-clicked="handleBreadcrumbClick"
                :contentModifiers="createContentModifiers()"
            />
        </div>
        <peak-ahead/>
        <astm-modal/>
        <bookmark-modal/>
        <notes-modal/>
        <premium-tools-access-restriction-modal></premium-tools-access-restriction-modal>

        <!-- TODO: add NoteSectionToolbarMobile -->

    </div>
</template>

<script>
import ContentSection from "./ContentSection.vue";
import ContentSectionType from "./types/contentSectionType";
import BookmarkModal from "../titles/notesModal/bookmarkModal.vue";
import NotesModal from "../titles/notesModal/notesModal.vue";
import PeakAhead from "../../components/titles/peakAhead/index.vue";
import AstmModal from '../modals/astmModal.vue';
import DefaultContentModifier from "./content-modifiers/DefaultContentModifier";
import ContentUtils from "../titles/inc/contentUtils";
import Constants from "../../constants";
import helper from "../inc/mixins/helper";
import {ContentSectionApi} from "../../api/ContentSectionApi";
import ContentSectionBreadcrumb from "./ContentSectionBreadcrumb.vue";
import PremiumToolsAccessRestrictionModal from "../modals/PremiumToolsAccessRestrictionModal.vue";

export default {
    components: {
        PremiumToolsAccessRestrictionModal,
        ContentSectionBreadcrumb, ContentSection, BookmarkModal, NotesModal, PeakAhead, AstmModal
    },
    data() {
        return {
            /**
             * @type {Array<ContentSectionType>}
             */
            contentSections: [],
            isLoading: false,
            hasError: false,
            xmlIds: "",
        }
    },
    props: {
        xmlIdsQuery: {
            required: true,
            type: String
        },
    },
    watch: {
        // We watch the prop here so when it changes we change the contentSections array
        async xmlIdsQuery(newVal, oldVal) {
            await this.handleQueryChange(newVal);
        }
    },
    methods: {
        handleBreadcrumbClick(breadcrumbItem) {
            // TODO:: For search we will record the breadcrumb click to gtm and the backend
            console.log('Breadcrumb clicked from grandchild:', breadcrumbItem);
        },
        createContentModifiers() {
            //TODO:: this should be refactored
            const defaultContentModifier = new DefaultContentModifier(Routing, this.$http, ContentUtils, helper, Constants, _);
            return [defaultContentModifier];
        },
        async handleQueryChange(xmlIds) {
            this.setLoading(true);
            try {
                this.contentSections = await ContentSectionApi.queryXmlIds(xmlIds);
            } catch (err) {
                this.hasError = true;
            }
            this.hasError = false;
            this.setLoading(false);
        },
        setLoading(value) {
            this.isLoading = value
            this.$emit('loading', value);
        }
    },
}

</script>

<style scoped lang="scss">

</style>